export default __webpack_public_path__ + "static/media/CombineHarvester.392ab089.jpg";